import type { ReactElement } from 'react';

interface IToast {
  button?: {
    onClick: () => void;
    tk: string;
  };
  icon?: ReactElement;
  message: string;
}

export interface ToastProps extends IToast {
  duration?: number;
  msgDynamicValues?: string[];
  onClose: () => void;
}

export interface ToastConnectedProps extends IToast {
  timeStamp: number;
}

export enum ToastType {
  AUTOPLAY_CONTINUED_NO_CHANGES = 'AUTOPLAY_CONTINUED_NO_CHANGES',
  MAX_PAYOUT_REACHED = 'MAX_PAYOUT_REACHED',
  TABLE_WILL_CLOSE = 'TABLE_WILL_CLOSE',
  TOAST_GAME_CANCELLED = 'TOAST_GAME_CANCELLED',
  TOAST_SUBTITLES_OFF = 'TOAST_SUBTITLES_OFF',
  TOAST_BET_ABOVE_MINIMUM = 'TOAST_BET_ABOVE_MINIMUM',
}
